import { LogOut, ShieldCheck, UserRound, Factory, Store } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { NotificationBell } from "@/components/NotificationBell";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Button } from "@/components/ui/button";

const ROLE_LABEL = { admin: "Admin", production: "Produkcja", employee: "Handlowiec" };

export const Header = () => {
  const { user, logout, roleView, setRoleView } = useAuth();
  const isDual = user.role === "admin" && user.dual_role;
  const RoleIcon = user.role === "admin" ? ShieldCheck : user.role === "production" ? Factory : UserRound;
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-background/85 border-b border-border">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Logo />
        <div className="flex items-center gap-3">
          {isDual && (
            <div data-testid="view-switcher" className="flex items-center rounded-full border border-border bg-card p-0.5">
              <button data-testid="view-switch-employee" onClick={() => setRoleView("employee")}
                className={`flex items-center gap-1.5 rounded-full px-2.5 sm:px-3 py-1.5 text-xs font-semibold uppercase tracking-wider transition-colors ${roleView === "employee" ? "bg-amber-400 text-[#0D1117]" : "text-muted-foreground hover:text-foreground"}`}>
                <UserRound className="h-3.5 w-3.5" /><span className="hidden sm:inline">Handlowiec</span>
              </button>
              <button data-testid="view-switch-admin" onClick={() => setRoleView("admin")}
                className={`flex items-center gap-1.5 rounded-full px-2.5 sm:px-3 py-1.5 text-xs font-semibold uppercase tracking-wider transition-colors ${roleView === "admin" ? "bg-amber-400 text-[#0D1117]" : "text-muted-foreground hover:text-foreground"}`}>
                <ShieldCheck className="h-3.5 w-3.5" /><span className="hidden sm:inline">Administrator</span>
              </button>
            </div>
          )}
          {user.role === "employee" && <NotificationBell />}
          {user.role === "production" && <NotificationBell />}
          {(user.role === "admin" || user.role === "employee") && (
            <a data-testid="open-shop-link" href="/sklep" target="_blank" rel="noopener noreferrer"
              title="Otwórz sklep w nowej karcie (bez wylogowania)"
              className="flex items-center gap-1.5 rounded-full border border-border bg-card px-2.5 sm:px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground transition-colors hover:text-foreground hover:border-amber-400">
              <Store className="h-3.5 w-3.5" /><span className="hidden sm:inline">Sklep</span>
            </a>
          )}
          <ThemeToggle />
          <div data-testid="active-user-badge" className="hidden sm:flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1.5 text-sm">
            <RoleIcon className="h-4 w-4 text-amber-400" />
            <span className="font-medium">{user.name}</span>
            <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{isDual ? (roleView === "admin" ? "Admin" : "Handlowiec") : (ROLE_LABEL[user.role] || user.role)}</span>
          </div>
          <Button data-testid="logout-button" variant="ghost" size="sm" onClick={logout} className="gap-2">
            <LogOut className="h-4 w-4" /><span className="hidden sm:inline">Wyloguj</span>
          </Button>
        </div>
      </div>
    </header>
  );
};
